import { expVal } from '@confluence/feature-experiments';

let store: any | null = null;

function getStore() {
	const AsyncLocalStorage = (globalThis as any)?.__vm_internals__?.asyncLocalStorage
		?.AsyncLocalStorage;

	if (!AsyncLocalStorage || !expVal('block_network_requests_from_rendering', 'isEnabled', false)) {
		return null;
	}
	if (!store) {
		store = new AsyncLocalStorage();
	}
	return store;
}

export function runInQueryBoundary(name: string, callback: () => void) {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const store = getStore();
		if (!store) {
			return callback();
		}
		return store.run(name, callback);
	}
	return callback();
}

export function getQueryBoundary(): string | null {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const store = getStore();
		if (!store) {
			return null;
		}
		return store.getStore();
	}
	return null;
}
